module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Bold.696760d1.woff";